import { render } from "./flex.vue?vue&type=template&id=4e727fed&scoped=true"
import script from "./flex.vue?vue&type=script&lang=js"
export * from "./flex.vue?vue&type=script&lang=js"

import "./flex.vue?vue&type=style&index=0&id=4e727fed&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e727fed"]])

export default __exports__